var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"manage-cookies text-small",attrs:{"href":"#","loading":"lazy"},on:{"click":function($event){$event.preventDefault();return _vm.onManageCookiesClick($event)}}},[_vm._v("\n  Manage Cookies\n")])}
var staticRenderFns = []

export { render, staticRenderFns }